// @flow
import * as R from "ramda"

import fetchApi from "./api"

const SET_LOCALE = "options/SET_LOCALE"
const FETCH_LOCALE = "options/FETCH_LOCALE"
// const FETCH_LOCALE_REQUEST = "options/FETCH_LOCALE_REQUEST"
const FETCH_LOCALE_SUCCESS = "options/FETCH_LOCALE_SUCCESS"
// const FETCH_LOCALE_FAILURE = "options/FETCH_LOCALE_FAILURE"

// NEW TRANSLATIONS
// ===
// only for development
// when merging PR, upload these to PhraseApp to be actually translated

// use flat format {"a.b.c": "text"}
// ---

// ------------------------ temp place for translations - don't let it in master -----------------------

export const NEW_TRANSLATIONS = {}

// -------------------------------------- this is on master---------------------------------------------

type Action = {
  type: string,
  res: {},
}

export type IntlState = { [key: string]: string }

export default function translationsReducer(state: IntlState = {}, action: Action) {
  switch (action.type) {
    case FETCH_LOCALE_SUCCESS:
      return NEW_TRANSLATIONS ? R.mergeDeepRight(action.res, NEW_TRANSLATIONS) : action.res

    case SET_LOCALE:
      return NEW_TRANSLATIONS ? R.mergeDeepRight(action.res, NEW_TRANSLATIONS) : action.res

    default:
      return state
  }
}

export const fetchLocale = (loc: string) => ({
  type: FETCH_LOCALE,
  promise: fetchApi(loc),
})

export const setLocale = (translations: *): Action => ({
  type: FETCH_LOCALE_SUCCESS,
  res: translations,
})

type State = { +translations: IntlState }

export const getTranslations = (state: State) => state.translations
